<template>
  <a-card  style="margin-top: 5px">
    <a-table :columns="columns" :data-source="data"
             rowKey="id"
             size="small"
             :pagination="false"
    >
      <span slot="nameEn" slot-scope="text,record,index">
        <template v-if="!edit">
          {{text}}
        </template>
         <a-input v-else v-model="record.nameEn" />
      </span>
      <span slot="required" slot-scope="text,record,index">
        <template v-if="!edit">
          {{text==='1'?'是':text==='0'?'否':'-'}}
        </template>
         <a-radio-group v-else-if="record.required" v-model="record.required">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
      </span>
      <span slot="export" slot-scope="text,record,index">
        <template v-if="!edit">
          {{record.exportInfo_dictText}}
        </template>
         <a-radio-group v-else v-model="record.exportInfo">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
      </span>
      <span slot="export2" slot-scope="text,record,index">
        <template v-if="!edit">
          {{record.exportData_dictText}}
        </template>
         <a-radio-group v-else v-model="record.exportData">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
      </span>
      <!-- <span slot="savePix" slot-scope="text,record,index">
        <template v-if="!edit">
          {{record.savePix_dictText}}
        </template>
         <a-radio-group v-else v-model="record.savePix">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
      </span> -->
    </a-table>
    <div style="margin-top: 10px">
      <a-button  type="primary" @click="handleEdit" v-if="!edit">编辑</a-button>
      <template v-else>
        <a-button   @click="handleCancel">取消</a-button>
        <a-button  type="primary" @click="handleSubmit" style="margin-left: 20px">保存</a-button>
      </template>
    </div>
  </a-card>
</template>

<script>
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import Vue from 'vue'
  import { getAction,postAction } from '@/api/manage'
  export default {
    name: 'PatientBaseFieldSet',
    data(){
      return{
        columns:[
          {
            title: '名称',
            align:'center',
            dataIndex: 'name',
          },
          // {
          //   title: '英文名称',
          //   align:'center',
          //   dataIndex: 'nameEn',
          //   scopedSlots: { customRender: 'nameEn' },
          // },
          {
            title: '必填',
            align:'center',
            dataIndex: 'required',
            scopedSlots: { customRender: 'required' },

          },
          {
            title: '是否导出（基本信息表）',
            align:'center',
            dataIndex: 'export',
            scopedSlots: { customRender: 'export' },

          },
          {
            title: '是否导出（采集数据表）',
            align:'center',
            dataIndex: 'export2',
            scopedSlots: { customRender: 'export2' },
          },
          // {
          //   title: '是否保存为交叉索引',
          //   align:'center',
          //   dataIndex: 'savePix',
          //   scopedSlots: { customRender: 'savePix' },
          // },
        ],
        data:[

        ],
        edit:false,
        projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
      }
    },
    mounted(){
      this.loadData()
    },
    methods:{
      loadData(){
        const params = {projectId:this.projectId,type:'1'}
        getAction('/project/projectPatientField/editList',params).then(res=>{
          if(res.success){
            this.data = res.result
          }
        })
      },
      handleEdit(){
        this.edit=true
      },
      handleCancel(){
        this.loadData()
        this.edit=false
      },
      handleSubmit(){
        postAction('/project/projectPatientField/editAll',this.data).then(res =>{
          if(res.success){
            this.$message.success(res.message)
          }else{
            this.$message.error(res.message)
          }
        }).finally(()=>{
          this.handleCancel()
        })
      },
    },
  }
</script>

<style scoped>

</style>